module.exports = __webpack_public_path__ + "img/d0fa39bf5062f22a93432901bc5229de.d0fa39bf.png";